<template>
  <div class="hello">

    <ui-modal ref="err_modal" title="Messages">
      <ui-alert type="error" :dismissible="false" v-if="messagesErreur.length > 0">
        <ul v-if="messagesErreur.length > 0">
          <li  v-for="item in messagesErreur" :key="item" >
            {{item}}
          </li >
        </ul>
      </ui-alert>


      <div  v-if="messagesErreur.length <= 0">
        <ui-alert type="success" :dismissible="false">
                        {{messageSucces}}
        </ui-alert>
      </div>
    </ui-modal>

<div v-if='!addMode'>
<table>
<tr>
  <td><ui-textbox label="Id" placeholder="" v-model="formUser.id"></ui-textbox></td>
  <td><ui-textbox label="Identifiant" placeholder="" v-model="formUser.userName"></ui-textbox></td>
</tr>
</table>



<ui-button :color="'green'" @click="chercher()">Chercher</ui-button>
<ui-button :color="'red'" @click="showFormAdd()" style="margin-left:5px;">Nouveu Utilisateur</ui-button>

<div v-if="hasNext || hasPrevious">
  <br>
  <ui-button :color="'green'" @click="precedent()" :disabled="!hasPrevious">Precedent</ui-button>
  <ui-button :color="'green'" @click="suivant()" :disabled="!hasNext">Suivant</ui-button>

</div>


<b-table striped hover :items="listSearch" :fields="fields">
  <!-- A virtual column -->

  <template #cell(actions)="data">
      <div>
        <ui-button :color="'red'" @click="update(data)">Modifier</ui-button>
      </div>

  </template>

</b-table>


</div>
<div v-if='addMode'>
  <div style="width:50%">
    <ui-textbox label="Identifiant" placeholder="" v-model="formUser.userName"></ui-textbox>
    <ui-textbox label="Mot de passe" placeholder="" type="password" v-model="formUser.password"></ui-textbox>
  </div>
  <h2>Roles : </h2>

  <div v-for="item in formUser.roles" :key="item.id">
       <ui-checkbox v-model="item.status" style="font-weight: bold;">{{item.role}}</ui-checkbox>
  </div>
  <br/>
  <ui-button :color="'green'" @click="enregistrer()">Enregistrer</ui-button>
  <ui-button :color="'red'" @click="annuler()" style="margin-left:5px;">Retour</ui-button>

</div>


  </div>
</template>

<script>
import { getUsers, saveUser, usersSearch } from '../services/ApiService.js'
export default {
  name: 'User',
  props: {

  },
  data() {

       return {
           dateDebut: null,
           dateFin: null,
           listSearch: null,
           hasNext:false,
           hasPrevious:false,
           addMode: false,
           showMessageSucces: false,
           messageSucces: '',

           showMessageErreur: false,
           messagesErreur: [],

           formUser : {
              id:null,
              userName:'',
              password:'',
              roles:[],
              currPage: 0
           },

           fields: [
                {
                  key: "id",
                  label: "Id",

                },
                {
                  key: "userName",
                  label: "Identifiant",

                },
                { key: "actions" }
              ]
         }
       },

       methods : {

         chercher() {
           usersSearch(this.formUser).then(response => {

              this.listSearch = response.data.content;
              this.hasNext = response.data.hasNext;
              this.hasPrevious = response.data.hasPrevious;

      }).catch(err => this.showResponseError(err))


    },

    suivant() {
      this.formUser.currPage = this.formUser.currPage + 1;
      this.chercher();
    },
    precedent() {
      this.formUser.currPage = this.formUser.currPage - 1;
      this.chercher();
    },

    showFormAdd() {
      this.addMode = true
    },
    enregistrer() {
      if(!this.valdateForm()) {
        this.$refs["err_modal"].open();
        return;
      }
      saveUser(this.formUser).then((evt) => {
         this.fillFormO(evt.data);
         this.showMessageSucces = true;
         this.messageSucces = "Personne enregistree avec succe";
         this.$refs["err_modal"].open();

     }).catch(err => this.showResponseError(err))

    },
    annuler() {
      this.resetForm()
      this.addMode = false
      this.showMessageSucces = false
      this.showMessageErreur = false
    },
    resetForm() {
      this.formUser.id = null;
      this.formUser.userName = '';
      this.formUser.password = '';
      this.formUser.roles=[];
    },
    fillFormO(obj) {
      this.formUser.id = obj.id;
      this.formUser.userName = obj.userName;
      this.formUser.roles= obj.roles;
    },
    fillForm(evts) {
      if(evts.length > 0) {
        this.fillFormO(evts[0]);
      } else {
        this.resetForm();
      }

    },

    valdateForm() {
      this.messagesErreur =[];
      if(!this.formUser.userName) {
        this.messagesErreur.push("L'identifiant est obligatoire");
      }



      this.showMessageErreur = this.messagesErreur.length > 0 ;
      return !this.showMessageErreur;

    },

    update(data) {

      this.resetForm();

      getUsers(this.listSearch[data.index].id).then(response => {
         this.fillForm(response.data);
         this.showFormAdd();
      }).catch(err => this.showResponseError(err))


    },
    showResponseError(err) {
      this.messagesErreur =[];
      if(err.status === 403) {
        this.messagesErreur.push("Acces refuse");
      } else {
        this.messagesErreur.push("Erreur technique");
      }
      this.showMessageErreur = true;
      this.$refs["err_modal"].open();
    },

       }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
